import { TierList } from "./type";

const formatDate = (date: string) => {
  if (date === "") return "";

  const dateParse = new Date(date.slice(0, 10));
  return dateParse.toISOString().slice(0, 10).split("-").reverse().join("/");
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const sortTierList = (order: "asc" | "desc", tierListData: any): TierList[] => {
  const ascending = order.toLowerCase() === "asc" ? 1 : -1;
  const compareDates = (a: TierList, b: TierList) => {
    const dateA = new Date(a.startDate);
    const dateB = new Date(b.startDate);
    if (dateA < dateB) return -ascending;
    if (dateA > dateB) return ascending;
    return 0;
  };
  return tierListData.slice().sort(compareDates);
};

const getLDRelayURL = () => {
  let LDUser = window.location.origin;
  let env = "";
  const smilesDomain = window.location.hostname.indexOf("smiles.com.br") > -1;
  const rx = smilesDomain ? /^(.*)\.smiles\.com\.br/g : /^(.*)\.voebiz\.com\.br/g;
  const res = rx.exec(window.location.hostname);

  if (res !== null) {
    if (res.length > 1 && res[1] && res[1].length > 3) {
      // eslint-disable-next-line prefer-destructuring
      env = res[1];
    }
    env = env.replace(/portal|voebiz/g, "").replace("uat", "hml");
  }

  if (window.location.hostname === "localhost") {
    env = "-hml5";
    LDUser = "https://voebiz-uat5.smiles.com.br";
  }

  return { launchDarklyURL: `https://ldrelay${env}.smiles.com.br`, LDUser };
};

export { formatDate, sortTierList, getLDRelayURL };
